@if (explorerMedia(); as explorer) {
  <media-explorer [media]="explorer" (exit)="closeMediaExplorer()"></media-explorer>
} @else {
  <media-grid [entities]="entities()" 
              [mediaOf]="mediaOf"
              (select)="onSelect($event)">
    <ng-template #mediaDetails let-entity="entity" let-media="media">
      <div class="media-details">
        @let conference = media.properties?.conference;
        @let color = conference?.color;
        <!-- @if (conference?.color) {
          <div class="color" [style.backgroundColor]="conference?.color"></div>
        } -->
        <div class="details">
          <h6 cCardTitle>{{ media.name }}</h6>
          <svg cIcon name="moreVert" (click)="onDetails(entity)"></svg>
        </div>
        <!-- <span>{{media.properties?.conference?.timeFrom}} / {{media.properties?.conference?.timeTo}}</span> -->
        <ng-container *ngIf="media.type == 'conference' && media.properties?.conference?.timeFrom; let timeFrom">
          <c-badge cCardText class="start-time" [ngStyle]="color ? { color: contrastColor(color), backgroundColor: color} : undefined" >
            <svg cIcon name="cilCalendarEvent"></svg>
            {{ timeFrom | date: 'EEE, MMMM dd, HH:mm' }}
          </c-badge>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #mediaBadges let-index="index" let-entity="entity" let-media="media">
      @let badge = getBadgeInfo(media);
      @if (badge) {
      <div class="media-badge {{badge.class}}">
          <!-- <span *ngIf="badge.icon">{{badge.icon}}</mat-icon> -->
          <span *ngIf="badge.label">{{ badge.label | translate }}</span>
      </div>
      }
    </ng-template>
  </media-grid>
}

@let action = config?.action;
@if (action) {
  <adaptive-button
    [label]="action.label!" 
    [icon]="action.icon!" 
    (click)="onDetails(createNullEntity())">
  </adaptive-button>
}

<div #offcanvas
    class="media-offcanvas" 
    [@slideInOut]="displaySidebar() ? 'in' : 'out'"
    (@slideInOut.start)="onSlideInOutAnimationStart($event)"
    (@slideInOut.done)="onSlideInOutAnimationDone($event)">
  @let entity = selectedEntity();
  @let type = typeOf(entity);
  <div class="header">
      <h5 class="modal-title">{{`${type}.details` | translate}}</h5>
      <button type="button" 
              class="btn btn-close" 
              aria-label="Close" 
              (click)="closeSidebar()">
      </button>
  </div>
  <div #offcanvasContent class="content">
    <!-- <event-detail [event]="sampleEvent"></event-detail> -->
    @let editMode = selectedEntityEditMode();
    @if (entity!==undefined) {
      @if (type === 'event') {
        <event-detail
          #detail="eventDetail"
          [event$]="entity"
          [editMode$]="editMode">
          <ng-template #controlsTemplate let-event="event">
            <ng-container *ngTemplateOutlet="controls; context: { parent: detail, entity: entity }"></ng-container>
          </ng-template>
          <!-- 
          <ng-template #controlsTemplate let-event="event">
            <ng-container>
              <div class="d-grid gap-2 mt-4">
                <button
                    cButton
                    color="secondary"
                    (click)="onCancel(eventDetail.value$())">
                  {{'actions.cancel' | translate}}
                </button>
                @let formState = eventDetail.formState | async;
                @if (editMode && formState) {
                  <button
                      cButton
                      color="primary"
                      [disabled]="!(formState.valid && formState.dirty)"
                      (click)="onSave(eventDetail.value$()!)"
                  >
                  {{'actions.save' | translate}}
                  </button>
                  
                  <button
                    *ngIf="eventDetail.eventId$() as eventId"
                    cButton
                    color="danger"
                    (click)="onDelete(eventId)"
                  >
                    {{'actions.delete' | translate}}
                  </button>
                }
              </div>
            </ng-container>
          </ng-template> 
          -->
        </event-detail>
      } @else {
        <media-detail
          #detail="mediaDetail"
          [media$]="entity"
          [editMode$]="editMode">
          <ng-template #controlsTemplate let-event="event">
            <ng-container *ngTemplateOutlet="controls; context: { parent: detail, entity: entity }"></ng-container>
          </ng-template>
        </media-detail>
      }    
    }
  </div>
</div>

<ng-template #controls let-parent="parent" let-entity="entity">
  <div class="d-grid gap-2 mt-4">
    <button cButton color="secondary" (click)="onCancel(parent.value$())">
      {{ 'actions.cancel' | translate }}
    </button>
    @let editMode = parent.editMode$();
    @let formState = parent.formState$();
    @if (editMode && formState) {
      <button
        cButton
        color="primary"
        [disabled]="!(formState.valid && formState.dirty)"
        (click)="onSave(parent.value$()!)"
      >
        {{ 'actions.save' | translate }}
      </button>

      <button
        *ngIf="entity.id as entityId"
        cButton
        color="danger"
        (click)="onDelete(entityId)"
      >
        {{ 'actions.delete' | translate }}
      </button>
    }
  </div>
</ng-template>


<!-- <ng-container *translate="let t">
  <p>{{ t('welcome') }}</p>
</ng-container>
<ng-container *translate="let t; params: { name: 'John' }">
  <p>{{ t('name') }}</p>
</ng-container>
<div>{{ 'welcome' | translate }}</div> 
<span translate="name" [translateParams]="{ name: 'John' }"></span> -->